import { render, staticRenderFns } from "./VideoManage.vue?vue&type=template&id=13c46e19&scoped=true&"
import script from "./VideoManage.vue?vue&type=script&lang=js&"
export * from "./VideoManage.vue?vue&type=script&lang=js&"
import style0 from "./VideoManage.vue?vue&type=style&index=0&id=13c46e19&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c46e19",
  null
  
)

component.options.__file = "VideoManage.vue"
export default component.exports